import ErrorPage from './ErrorPage';

export const templates = {
	ErrorPage
};
